import React, { useEffect, useRef, useState } from 'react';
import EmojiPicker from 'emoji-picker-react';
import ReactDOM from 'react-dom';

const EditGroupPost = ({ post, onClose, onSave }) => {
  const [content, setContent] = useState(post.content || "");
  const [originalContent, setOriginalContent] = useState(post.content || "");
  const [isEditing, setIsEditing] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiButtonRef = useRef(null);

  const hasChanged = content !== originalContent;

  const handleSave = () => {
    const updatedPost = { ...post, content };
    onSave(updatedPost);
    setOriginalContent(content);
    setIsEditing(false);
    setShowEmojiPicker(false);
  };

  const handleEmojiClick = (emojiData) => {
    setContent((prev) => prev + emojiData.emoji);
  };

  // Close emoji picker if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        emojiButtonRef.current &&
        !emojiButtonRef.current.contains(e.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mt-3 relative pb-20">
      {" "}
      {/* Padding bottom for fixed footer */}
      {/* Editable content */}
      <div className="pb-3 mb-4 px-2">
        {isEditing ? (
          <textarea
            className="w-full rounded-md p-2 resize-none text-base leading-relaxed outline-none focus:outline-none focus:ring-0 focus:border-transparent border border-transparent"
            rows={2}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Write something..."
          />
        ) : (
          <div
            className="whitespace-pre-line break-words text-base leading-relaxed cursor-pointer"
            onClick={() => setIsEditing(true)}
            title="Click to edit"
          >
            {content || "No content available"}
          </div>
        )}
      </div>
      {/* Media content */}
      {post.media.length === 1 ? (
        <div className="relative rounded-lg overflow-hidden bg-gray-100 flex justify-center px-2">
          <img
            src={post.media[0].url}
            alt="Post media"
            className="w-full max-h-[500px] object-contain cursor-pointer"
            onClick={() =>
              window.open(
                post.media[0].display_url || post.media[0].url,
                "_blank"
              )
            }
          />
          {post.media[0].type === "video" && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                <i className="fas fa-play text-white text-2xl"></i>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className={`grid gap-1 overflow-hidden px-2 ${
            post.media.length <= 3 ? "grid-cols-2" : "grid-cols-2"
          }`}
        >
          {post.media.slice(0, 4).map((mediaItem, index) => (
            <div
              key={mediaItem.id}
              className={`relative group cursor-pointer flex justify-center ${
                post.media.length === 3 && index === 2 ? "col-span-2" : ""
              }`}
              
            >
              <img
                src={mediaItem.url}
                alt="Post media"
                className="w-full h-full object-cover bg-gray-100"
              />
              {index === 3 && post.media.length > 4 && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                  +{post.media.length - 4}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Fixed Action Buttons Footer */}
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-300 px-4 py-3 flex justify-between items-center gap-4 z-50">
        {isEditing && (
          <div /* ref={emojiButtonRef} */ className="relative">
            <button
              type="button"
              onClick={() => setShowEmojiPicker((prev) => !prev)}
              className="text-xl cursor-pointer"
            >
              😊
            </button>
          </div>
        )}
        <div className='flex gap-2'>
          <button
            onClick={handleSave}
            disabled={!hasChanged}
            className={`px-4 py-1 rounded ${
              hasChanged
                ? "bg-blue-500 text-white hover:bg-blue-600"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
            }`}
          >
            Save
          </button>
          <button
            onClick={() => {
              setContent(originalContent);
              setIsEditing(false);
              setShowEmojiPicker(false);
              onClose(); // close modal
            }}
            className="bg-gray-200 text-black px-4 py-1 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
        </div>
      </div>
      {/* Emoji Picker rendered in portal to escape modal boundaries */}
      {showEmojiPicker &&
        ReactDOM.createPortal(
          <div className="fixed z-[9999] bottom-20 right-10 bg-white shadow-lg rounded">
            <EmojiPicker onEmojiClick={(emojiData, event)=> handleEmojiClick(emojiData)} />
          </div>,
          document.body
        )}
    </div>
  );
};

export default EditGroupPost;
